export const images = [
    require('../img/screens/11.png'),
    require('../img/screens/22.png'),
    require('../img/screens/33.png'),
    require('../img/screens/44.png'),
    require('../img/screens/55.png'),
    require('../img/screens/66.png'),
    require('../img/screens/77.png'),
    require('../img/screens/88.png'),
];
